import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="performances--vacation-pattern-modal"
export default class extends Controller {
  static targets = ["customTimeSlice", "vacationTime", "attendanceRule"]
  connect() {
  }

  timeSliceChanged(event) {
    const timeSlice = event.currentTarget.value
    const url = new URL(`/attendance_rules/${this.attendanceRuleTarget.value}/time_slices/by_name/${timeSlice}`, window.location.origin)
    get(url, { responseKind: "json" })
      .then(response => {
        if (!response.ok) {
          throw response
        }
        return response.json
      })
      .then(result => {
        const { duration } = result
        const hours = Math.floor(duration / 60)
        const minutes = duration % 60
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
        this.vacationTimeTarget.value = formattedTime
        this.customTimeSliceTarget.checked = false
      })
  }

  handleVacationTimeInput() {
    if (this.vacationTimeTarget.value && this.vacationTimeTarget.value !== "--:--") {
      this.customTimeSliceTarget.checked = true
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()

    const form = this.element.querySelector("form")
    if (!form) return
    const dateInput = form.querySelector('[name*="date"]')
    const date = dateInput?.value
    const formAction = event.currentTarget.formAction

    // Check if there are any performance values for this date
    if (this.hasPerformanceData(date)) {
      const message = "確定すると、この日の勤務実績が上書きされます。よろしいですか？"
      if (confirm(message)) {
        this.#submitForm(form, formAction)
      }
    } else {
      this.#submitForm(form, formAction)
    }
  }


  hasPerformanceData(date) {
    const attendanceRow = document.querySelector(`tr[data-date="${date}"]`)
    if (!attendanceRow) return false

    const performanceFields = attendanceRow.querySelectorAll(".performances-field")
    if (performanceFields.length === 0) return false

    for (const field of performanceFields) {
      const projectPart = field.querySelector(".project-part")?.value
      const sliceStart = this.#timeValue(field, ".slice-start")
      const sliceEnd = this.#timeValue(field, ".slice-end")
      const workTimeSpan = this.#timeValue(field, ".work-time-span")
      const workManDays = field.querySelector(".work-man-days")?.value
      const workType = field.querySelector(".work-type")?.value
      const tool = field.querySelector(".tool")?.value
      const toolTimeSpan = this.#timeValue(field, ".tool-time-span")
      const toolManDays = field.querySelector(".tool-man-days")?.value
      const toolLeaseNumber = field.querySelector('[name*="tool_lease_number"]')?.value

      if (projectPart || sliceStart || sliceEnd || workTimeSpan || workManDays ||
        workType || tool || toolTimeSpan || toolManDays || toolLeaseNumber) {
        return true
      }
    }

    return false
  }

  #submitForm(form, formAction) {
    form.action = formAction || form.action
    if (formAction) {
      form.action = formAction
    }
    form.requestSubmit()
  }

  #timeValue(field, selector) {
    const value = field.querySelector(selector)?.value
    console.log()
    return value && value !== "--:--" ? value : ""
  }
}
